import { LegendOrdinal, LegendItem, LegendLabel } from '@visx/legend'
import { ScaleOrdinal } from 'd3-scale'
import { has } from 'lodash'
import { seriesStyle } from 'lib/chartColors'
import { capitalizeCamelCase } from 'app/utils'

const DEFAULT_FORMAT_TOTAL = (value: number) => `${value}`

type LegendOrdinalProps = {
  scale: ScaleOrdinal<string, string>
  domain: string[]
  totals?: { [key: string]: number }
  getColor?: (key: string) => string
  /** Formats the per-series total. Defaults to the raw number. */
  formatTotal?: (value: number) => string
  /** Show series keys exactly as given. By default camelCase keys are split into words, which also splits acronyms and brand names ("GPT" → "G P T"). */
  rawLabels?: boolean
}

export default function CommonLegendOrdinal({
  scale,
  domain,
  totals,
  getColor,
  formatTotal = DEFAULT_FORMAT_TOTAL,
  rawLabels = false,
}: LegendOrdinalProps) {
  return (
    <LegendOrdinal scale={scale} direction="row" labelMargin="0 15px 0 0">
      {(labels) => (
        <div className="flex flex-wrap gap-y-1">
          {domain.map((label, i) => {
            const style = seriesStyle(getColor ? getColor(label) : scale(label))
            return (
              <LegendItem key={`legend-quantile-${i}`} margin="0 12px" className="flex items-center whitespace-nowrap">
                <svg width="10" height="10">
                  <circle fill={style.fill} stroke={style.stroke} strokeWidth={1} r={4.5} cx={5} cy={5} />
                </svg>
                <LegendLabel className="flex items-center">
                  <div className="ml-2 text-body-sm capitalize text-default">
                    {rawLabels ? label : capitalizeCamelCase(label)}
                  </div>
                  {totals && has(totals, label) ? (
                    <div className="ml-1 text-ui-sm text-default">{formatTotal(totals[label])}</div>
                  ) : null}
                </LegendLabel>
              </LegendItem>
            )
          })}
        </div>
      )}
    </LegendOrdinal>
  )
}
